import { AccordionMenuPanel } from "./accordion-menu-panel.js";
import { styles } from "./accordion-menu-panel.styles.js";
import { template } from "./accordion-menu-panel.template.js";
import { DesignSystem } from "../design-system.js";
export const definition = AccordionMenuPanel.compose({
    name: `${DesignSystem.prefix}-accordion-menu-panel`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=accordion-menu-panel.definition.js.map